import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon CarouselArrowRightIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const CarouselArrowRightIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 10 20">
      <path d="M1 0a1 1 0 01.78.35l7.94 9a1 1 0 010 1.3l-7.94 9a1 1 0 01-1.45.11 1 1 0 01-.11-1.41L7.61 10 .25 1.65A1 1 0 01.36.24 1 1 0 011 0z" />
    </Icon>
  )
}
export default CarouselArrowRightIcon
